import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { RESTDataSource } from 'app/helpers/rest.datasource';
import { OfferIface } from 'app/interfaces/offer.iface';
import { OffersService } from 'app/services/offers.service';
import { Status } from 'app/interfaces/status';
import { StatusService } from 'app/services/status.service';
import { AuthService } from 'app/services/auth.service';
import { Tag } from 'app/interfaces/tag';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-offers-status-dialog',
  templateUrl: './mass-status-change-dialog.component.html',
  styleUrls: ['./mass-status-change-dialog.component.scss']
})
export class MassStatusChangeDialogComponent implements OnInit, OnDestroy {
  public newStatusCode = '';
  public statusToChange: Status;
  public dataSource: RESTDataSource<OfferIface>;
  public offerLifeCycleStatus: Status[];
  public isLoadingResults = false;
  private activeTags: Tag[] = [];
  private subscriptions: Subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<MassStatusChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private offersService: OffersService,
    private statusService: StatusService,
    private authService: AuthService,
    private toastr: ToastsManager,
    public translate: TranslateService
  ) {
    this.activeTags = data.activeTags;
    this.statusToChange = data.selectedStatus;
  }

  ngOnInit() {
    this.dataSource = new RESTDataSource(this.offersService);
    this.loadData();

    this.subscriptions.add(
      this.statusService.getStatusesWithEditPermForRoles(this.authService.user.roles).subscribe(statuses => {
        this.offerLifeCycleStatus = statuses.filter(status => status.statusCode !== this.statusToChange.statusCode);
      })
    );
  }

  loadData() {
    const query = this.createQuery();
    this.dataSource.loadData(query, 0, 0, 'status');
  }

  save(): void {
    this.isLoadingResults = true;
    let query = this.createQuery();
    query = Object.assign(query, { newStatusCode: this.newStatusCode });
    this.offersService.massUpdate(query, 'updateStatus').subscribe(
      () => {
        this.toastr.success(
          this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.SUCCESS'),
          this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.SUCCESS_TITLE')
        );
        this.isLoadingResults = false;
        this.dialogRef.close(true);
      },
      error => {
        this.isLoadingResults = false;
        if (error.status === 406) {
          this.toastr.error(
            error.error.error,
            this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.ERROR_TITLE')
          );
        } else {
          this.toastr.error(
            this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.ERROR'),
            this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.ERROR_TITLE')
          );
        }
      }
    );
  }

  close() {
    this.dialogRef.close(false);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private createQuery() {
    let query = {};
    const activeTags = this.activeTags.map(activeTag => activeTag.value);
    if (activeTags.length) {
      query = Object.assign(query, { 'tags.value': { $all: activeTags } });
    }
    query = Object.assign(query, { offerStatus: this.statusToChange.statusCode });
    return query;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-list/mass-status-change-dialog/mass-status-change-dialog.component.ts